import { render, staticRenderFns } from "./Sincronizacao.vue?vue&type=template&id=542cdd28&scoped=true&"
import script from "./Sincronizacao.vue?vue&type=script&lang=js&"
export * from "./Sincronizacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542cdd28",
  null
  
)

export default component.exports